import { useEffect, useState } from 'react';
import { getCenterCostFromApi, getCenterCostListByTypeFromApi } from '../../../../api/CenterCost/centerCosts';
import { getRolesByGroupFromApi } from '../../../../api/Roles/roles';
import errorMessage from '../../../../helpers/errorMessage';
import { Role } from '../../../../redux/user/definitions';
import CenterCostType from '../../../../types/Accounting/CenterCost/CenterCostType';
import { CenterCostData } from '../../../../types/Accounting/CenterCost/CenterCostTypes';
import RoleGroup from '../../../../types/Roles/roleGroup';

interface StateFilterData {
  [key: string]: string;
}

type UseCenterCostFormList = {
  loading: boolean;
  centerCost: CenterCostData;
  roles: Role[];
  relatedCenterCosts: CenterCostData[];
  errorListMessage: string | null;
};

const useCenterCostForm = (centerCostType: CenterCostType, id: number): UseCenterCostFormList => {
  const [centerCost, setCenterCost] = useState<CenterCostData>({} as CenterCostData);
  const [relatedCenterCosts, setRelatedCenterCosts] = useState<CenterCostData[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorListMessage, setErrorListMessage] = useState<string | null>(null);

  const fetchRelatedData = async (centerCostType: CenterCostType) => {
    const relatedType = centerCostType.relatedType();
    if (relatedType) {
      const relatedCosts = await getCenterCostListByTypeFromApi(relatedType.value());
      setRelatedCenterCosts(relatedCosts);
    }
    if (centerCostType.isChannel() || centerCostType.isDelegation()) {
      const roles = await getRolesByGroupFromApi(RoleGroup.nouscims());
      setRoles(roles);
    }
  };

  useEffect(() => {
    setLoading(true);
    setErrorListMessage(null);

    if (id === 0) {
      setCenterCost({
        id: 0,
        code: '',
        name: '',
        role_code: null,
        delegation_code: null,
        channel_code: null,
        area_code: null,
      });
      fetchRelatedData(centerCostType)
        .catch(error => {
          setErrorListMessage(errorMessage(error));
        })
        .finally(() => setLoading(false));
      return;
    }

    getCenterCostFromApi(centerCostType.value(), id)
      .then((data: CenterCostData) => {
        setCenterCost(data);
        return fetchRelatedData(centerCostType);
      })
      .catch(error => {
        setErrorListMessage(errorMessage(error));
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    centerCost,
    roles,
    relatedCenterCosts,
    loading,
    errorListMessage,
  };
};

export default useCenterCostForm;
